// Mock data for ARIA WEALTH website

export const navigationLinks = [
  { name: 'Home', path: '/', icon: 'Home' },
  { name: 'About Us', path: '/about', icon: 'Users' },
  { name: 'Services', path: '/services', icon: 'Briefcase' },
  { name: 'Calculators', path: '/calculators', icon: 'Calculator' },
  { name: 'Financial Wisdom', path: '/financial-wisdom', icon: 'BookOpen' },
  { name: 'Contact', path: '/contact', icon: 'Phone' },
];

export const heroData = {
  title: 'Your Goals Stay the Course',
  subtitle: 'AMFI Registered Mutual Fund Distributor',
  description: 'Clarity, discipline, and guidance — helping you stay aligned with what truly matters.',
  ctaText: 'Start Your SIP Journey',
  ctaLink: '/calculators'
};

export const servicesData = [
  {
    id: 1,
    title: 'Mutual Fund & SIP Investments',
    description: 'Diversified portfolio management with systematic investment plans tailored to your goals.',
    icon: 'TrendingUp',
    features: ['Goal-based solutions', 'Risk assessment', 'Regular monitoring', 'Tax optimization']
  },
  {
    id: 2,
    title: 'Financial Guidance',
    description: 'Comprehensive financial roadmap for achieving your life goals and securing your future.',
    icon: 'Target',
    features: ['Retirement solutions', 'Child education', 'Emergency funds', 'Wealth accumulation']
  },
  {
    id: 3,
    title: 'Insurance Solutions',
    description: 'Complete insurance solutions to protect your family and assets from unforeseen circumstances.',
    icon: 'Shield',
    features: ['Life insurance', 'Health coverage', 'Critical illness', 'Disability protection']
  },
  {
    id: 4,
    title: 'Goal-Based Solutions',
    description: 'Strategic guidance for specific life goals with dedicated investment approaches.',
    icon: 'Flag',
    features: ['Home buying', 'Vacation goals', 'Business expansion', 'Debt management']
  },
  {
    id: 5,
    title: 'Retirement Solutions',
    description: 'Secure your golden years with systematic retirement corpus building and income strategy.',
    icon: 'PiggyBank',
    features: ['Pension solutions', 'Corpus calculation', 'Income strategy', 'Post-retirement support']
  }
];

export const calculatorsData = [
  {
    id: 1,
    title: 'SIP Calculator',
    description: 'Calculate your systematic investment plan returns and work toward your financial goals.',
    icon: 'Calculator',
    path: '/calculators/sip'
  },
  {
    id: 2,
    title: 'Lumpsum Calculator',
    description: 'Evaluate returns on one-time investments in mutual funds and other instruments.',
    icon: 'DollarSign',
    path: '/calculators/lumpsum'
  },
  {
    id: 3,
    title: 'Retirement Goal Calculator',
    description: 'Estimate your retirement corpus and determine monthly savings required.',
    icon: 'PiggyBank',
    path: '/calculators/retirement'
  },
  {
    id: 4,
    title: 'Inflation Calculator',
    description: 'Understand the impact of inflation on your savings and purchasing power.',
    icon: 'TrendingUp',
    path: '/calculators/inflation'
  },
  {
    id: 5,
    title: 'Dream Goal Calculator',
    description: 'Calculate how much to save monthly to achieve your dream goals.',
    icon: 'Star',
    path: '/calculators/dream-goal'
  }
];

export const companyValues = [
  {
    title: 'We Listen Before We Guide',
    description: 'Your story, your concerns, and your aspirations come first. Meaningful guidance begins with understanding — not assumptions. We take time to know what truly matters to you, so every decision stays aligned with your life goals.',
    icon: 'Ear'
  },
  {
    title: 'Transparent & Honest Communication',
    description: 'No confusion. No hidden agendas. We simplify concepts, explain risks clearly, and help you make informed choices. Transparency is our foundation — always.',
    icon: 'MessageSquare'
  },
  {
    title: 'A Disciplined, Process-Driven Approach',
    description: 'We don\'t chase trends or react to noise. Our approach is structured, long-term, and rooted in suitability, asset allocation, and risk awareness. This discipline helps you stay focused through market movements.',
    icon: 'Target'
  },
  {
    title: 'Guidance That Supports Every Life Stage',
    description: 'Your financial journey evolves with life — career, family, responsibilities, and retirement. We help you stay prepared and aligned at every stage with clarity and purpose.',
    icon: 'Users'
  },
  {
    title: 'Behavioural Support During Market Ups & Downs',
    description: 'Markets fluctuate — emotions do too. We help you avoid impulsive decisions and stay grounded in your long-term strategy, especially during periods of uncertainty.',
    icon: 'TrendingUp'
  },
  {
    title: 'Ethical Standards & Complete Integrity',
    description: 'Your trust is our biggest responsibility. We maintain strict confidentiality, follow all regulatory guidelines, and ensure every recommendation is suitability-based.',
    icon: 'Shield'
  },
  {
    title: 'Simplified Guidance for Complex Decisions',
    description: 'From investment categories to risk profiling, from documentation to next steps — we break things down in a way that feels simple, clear, and easy to act on.',
    icon: 'Lightbulb'
  },
  {
    title: 'Long-Term Partnership, Not One-Time Transactions',
    description: 'We walk with you — reviewing progress, checking suitability, understanding changing needs, and staying available whenever you need support. Your journey matters to us, not just your investments.',
    icon: 'Handshake'
  }
];

export const financialWisdomData = [
  {
    id: 1,
    title: 'SIP vs Lumpsum: Which is Better?',
    category: 'Beginner',
    excerpt: 'Understanding the differences between systematic investment plans and lump sum investments.',
    readTime: '5 min read',
    publishDate: '2024-12-15',
    image: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=400&h=250&fit=crop',
    content: 'Detailed comparison between SIP and lumpsum investment strategies...'
  },
  {
    id: 2,
    title: 'Building Your Emergency Fund',
    category: 'Wealth Builder',
    excerpt: 'Learn how to create and maintain an emergency fund for financial security.',
    readTime: '7 min read',
    publishDate: '2024-12-10',
    image: 'https://images.unsplash.com/photo-1579621970563-ebec7560ff3e?w=400&h=250&fit=crop',
    content: 'Step-by-step guide to building your emergency fund...'
  },
  {
    id: 3,
    title: 'Path to Financial Freedom',
    category: 'Freedom Seeker',
    excerpt: 'Advanced strategies for achieving complete financial independence.',
    readTime: '10 min read',
    publishDate: '2024-12-05',
    image: 'https://images.unsplash.com/photo-1553729459-efe14ef6055d?w=400&h=250&fit=crop',
    content: 'Comprehensive guide to financial freedom...'
  }
];

export const contactInfo = {
  address: 'C-4104, Oberoi Garden Estate, Chandivali farm road, Chandivali Mumbai-400072, Maharashtra, India',
  phone: '+91 79775 23663',
  email: 'info@ariawealth.com',
  whatsapp: '+91 79775 23663',
  office_hours: 'Monday - Friday: 10:00 AM - 6:00 PM\nSaturday: 10:00 AM - 2:00 PM',
  map_embed: 'https://maps.app.goo.gl/3yS8A1LvgeU4EjBKAhttps://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2319.3353290420496!2d72.89046898484229!3d19.114661531263266!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c80be52e9935%3A0xe3e4e5bfc340be44!2sOberoi%20Garden!5e1!3m2!1sen!2sin!4v1763114594882!5m2!1sen!2sin" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade'
};

export const complianceData = {
  sebi_disclaimer: 'Mutual Fund investments are subject to market risks, read all scheme related documents carefully.',
  amfi_registration: 'AMFI Registration No: ARN-100804 | Date of Registration: 20/02/2024 | Valid till: 20/02/2027',
  operating_guidelines: [
    'SIP bounce policy: Maximum 3 consecutive bounces allowed',
    'Exit load: As per scheme information document',
    'Redemption TAT: T+2 working days for equity funds, T+1 for debt funds',
    'Investment limit: Minimum ₹500 per month for SIP, ₹5000 for lump sum',
    'KYC compliance: Mandatory for all investments above ₹50,000'
  ]
};

export const socialLinks = {
  linkedin: 'https://linkedin.com/company/ariawealth',
  instagram: 'https://instagram.com/ariawealth',
  twitter: 'https://twitter.com/ariawealth',
  facebook: 'https://facebook.com/ariawealth',
  whatsapp: 'https://wa.me/919876543210'
};